import { useState, useEffect } from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import SidebarIcons from "../common/SidebarIcons";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import dashlogo from "../../assets/img/dashbarlogo.png";
import { BOOKING_HISTORY } from "../../api/apiPath";
import http from "../../api/server";
import PdfPreviewIframe from "../common/PdfPreviewIframe";
import Toaster from "../common/Toaster";
import StatusPill from "../common/StatusPill";
import dayjs from "dayjs";

export default function BookingHistory() {
  const [open, setOpen] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);
  const { inspectionMasterId } = useParams();
  const [hideSidebar, setHideSidebar] = useState(false);
  const { userObj } = useSelector((state) => state.user);

  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const navigate = useNavigate();

  const [steps, setSteps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState({});

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  // const BASE_STATUSES = [
  //   "Property Onboarded",
  //   "Inspection Created",
  //   "Inspection Scheduled",
  //   "Inspection Started",
  //   "Submitted For Approval",
  //   "Approved",
  // ];

  // const REJECTION_STATUSES = ["Rejected", "Inspection Rejected"];

  /*--------------
  Fetch booking history and build timeline steps based on API response
  --------------*/
  useEffect(() => {
    const fetchBookingHistory = async () => {
      try {
        setLoading(true);

        const { data } = await http.get(BOOKING_HISTORY, {
          params: {
            clientId: userObj?.clientId,
            inspectionReferenceNumber: inspectionMasterId,
          },
        });

        const summaryData = data?.summary;
        setSummary(summaryData);

        const eventData = data?.events || [];

        // const rejectionFromApi = REJECTION_STATUSES.filter((status) =>
        //   eventData.some((e) => e.eventType === status),
        // );
        // const hasRejection = rejectionFromApi.length > 0;

        // const FINAL_STATUSES = hasRejection
        //   ? BASE_STATUSES.filter((s) => s !== "Approved").concat(
        //       rejectionFromApi,
        //     )
        //   : BASE_STATUSES;

        // const eventMap = eventData.reduce((acc, curr) => {
        //   acc[curr.eventType] = curr;
        //   return acc;
        // }, {});

        // const buildSteps = FINAL_STATUSES.map((status) => {
        //   const apiEvent = eventMap[status];

        //   return {
        //     title: status,
        //     completed: !!apiEvent,
        //     icon: apiEvent
        //       ? "fa-solid fa-circle-check"
        //       : "fa-regular fa-circle",
        //     date: apiEvent?.eventDate || "",
        //     performedBy: apiEvent?.performedBy || "",
        //     description: apiEvent?.comments || "",
        //   };
        // });

        // const lastCompletedIndex = buildSteps.reduce(
        //   (lastIndex, step, index) => (step.completed ? index : lastIndex),
        //   -1,
        // );

        // const nextStatusIndex = lastCompletedIndex + 1;

        // setSteps(
        //   buildSteps.map((step, index) => ({
        //     ...step,
        //     isActiveBar: index <= lastCompletedIndex,
        //     isCurrent: index === nextStatusIndex,
        //     isPending: index > nextStatusIndex,
        //   })),
        // );
        // Build timeline directly from API events (no filtering)
        const buildSteps = eventData.map((event) => ({
          title: event.eventType,
          completed: true,
          date: event.eventDate,
          performedBy: event.performedBy,
          description: event.comments || "",
        }));

        const lastIndex = buildSteps.length - 1;

        setSteps(
          buildSteps.map((step, index) => ({
            ...step,
            isActiveBar: index < lastIndex,
            isCurrent: index === lastIndex,
            isPending: false,
          })),
        );
      } catch (err) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: err.message || "Unknown error occurred",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchBookingHistory();
  }, [userObj?.clientId, inspectionMasterId]);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />

      {userObj && (
        <div className="dashboard_body_main vh-100">
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={closeButton}
          />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}

          <div className="d-flex dashboard_body flex-column py-1  w-100 mt-2">
            <div className="dashboard_header">
              <div>
                <h2 className="mb-0">Inspection History</h2>
                <p className="header-description mb-0">
                  Track the complete timeline of your site inspection
                </p>
              </div>
            </div>
            <div
              className="card mt-4 p-3 rounded-4 mb-4 orange-box d-flex gap-3 flex-row align-items-center justify-content-between"
              style={{ height: "9.5rem" }}
            >
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-evenly text-center py-4">
                  <div>
                    <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                      {summary?.totalDoors}
                    </h1>
                    <p className="fw-semibold mb-0">Total Doors</p>
                  </div>
                  <div className="col-6 col-sm-4 col-lg-2 mb-1">
                    <img src={dashlogo} alt="Inspector" height="100" />
                  </div>
                  <div>
                    <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                      {summary?.totalCriticalIssues}
                    </h1>
                    <p className="fw-semibold mb-0">Total Critical Issues</p>
                  </div>
                  <div>
                    <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                      {summary?.totalNonCompliantIssues}
                    </h1>
                    <p className="fw-semibold mb-0">
                      Total Non-Compliant Issues
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="resident-card mb-3">
              <div className=" flex-sm-row align-items-center ">
                <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h5 className="justifyStart fw-semibold mb-0 ">
                      {summary?.buildingName || summary?.propertyName}
                    </h5>

                    <p className="justifyCenter mb-0 mt-1">
                      <StatusPill status={summary?.inspectionStatus || ""} />
                    </p>
                  </div>

                  <p className="justifyStart text mb-0 mt-1">
                    {summary?.buildingName ? summary?.propertyName + ", " + summary?.propertyLocation : summary?.propertyLocation}
                  </p>

                  <div className="d-flex justify-content-between align-items-center w-100 mt-4 mb-4 text-black">
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ color: "#525254" }}>
                        Inspection Reference No :
                      </span>
                      <span>{inspectionMasterId || ""}</span>
                    </div>

                    <p className="d-flex align-items-center mb-0 gap-2">
                      <span style={{ color: "#525254" }}>
                        Inspection Managed By :
                      </span>
                      <span>{summary?.inspectionManagedBy}</span>
                    </p>
                  </div>
                </div>
                <div></div>
              </div>
            </div>

            <div className="resident-card mb-3">
              <div className=" flex-sm-row align-items-center ">
                <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                  <div className="step-header" onClick={() => setOpen(!open)}>
                    <p className="fw-semibold">{steps[0]?.title}</p>

                    <i
                      className={`bi ${
                        open ? "bi-chevron-up" : "bi-chevron-down"
                      }`}
                    ></i>
                  </div>
                  <div className="text-start">
                    {/* <p className="text"> {steps[0]?.date}</p> */}
                    <p className="text">
                      {steps[0]?.date
                        ? dayjs(steps[0]?.date, "DD-MMM-YYYY hh:mm A")
                            .format("DD-MMM-YYYY hh:mm A")
                            .toUpperCase()
                        : ""}
                    </p>
                  </div>
                  {open && (
                    <div className="step-details">
                      <p className="text">
                        {" "}
                        Building was successfully added to the system. All
                        initial information was verified and confirmed.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="resident-card mb-3">
              <div className=" flex-sm-row align-items-center ">
                <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                  <p className="text-start">
                    <b>Inspection Timeline</b>
                  </p>
                  <div className="bh-timeline">
                    {loading ? (
                      <p>Loading timeline...</p>
                    ) : steps.length > 0 ? (
                      steps.map((step, index) => (
                        <div className="bh-timeline-item-row" key={index}>
                          <div className="bh-timeline-left">
                            {index < steps.length - 1 && (
                              <div
                                className={`bh-timeline-bar ${
                                  step.isActiveBar
                                    ? "bh-bar-active"
                                    : "bh-bar-inactive"
                                }`}
                              ></div>
                            )}

                            <div
                              className={`bh-timeline-icon ${
                                step.isCurrent
                                  ? "bh-icon-current"
                                  : step.completed
                                    ? "bh-icon-completed"
                                    : "bh-icon-pending"
                              }`}
                            >
                              {step.isCurrent ? (
                                <div className="bh-current-dot"></div>
                              ) : step.completed ? (
                                <i
                                  className="fa-solid fa-check"
                                  style={{ fontSize: "10px", color: "#fff" }}
                                ></i>
                              ) : null}
                            </div>
                          </div>

                          {/* RIGHT SIDE: Event card */}
                          <div
                            className="bh-inspection-box text-start"
                            onClick={() =>
                              setOpenIndex(openIndex === index ? null : index)
                            }
                          >
                            <div className="bh-timeline-info">
                              <div className="d-flex align-items-center justify-content-between mb-0">
                                <div>
                                  <div className="bh-inspection-title-after fw-semibold mb-1">
                                    {step.title}
                                    <span> by - {step.performedBy}</span>
                                  </div>
                                </div>
                                <i
                                  className={`bi ${
                                    openIndex === index
                                      ? "bi-chevron-up"
                                      : "bi-chevron-down"
                                  }`}
                                  style={{ fontSize: "18px", color: "#737373" }}
                                ></i>
                              </div>

                              <div className="bh-inspection-date text mb-2">
                                {/* {step.date ||
                                  (step.isPending ? "Pending • TBD" : "")} */}
                                {step.date
                                  ? dayjs(step.date, "DD-MMM-YYYY hh:mm A")
                                      .format("DD-MMM-YYYY hh:mm A")
                                      .toUpperCase()
                                  : step.isPending
                                    ? "Pending • TBD"
                                    : ""}
                              </div>

                              {openIndex === index && step.description && (
                                <div className="bh-step-details mt-2">
                                  <p className="text">{step.description}</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No booking history found.</p>
                    )}
                  </div>
                  <div className="card-body action_btns d-flex justify-content-end gap-3 pb-3 px-3 flex-wrap flex-sm-nowrap">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleBack}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      )}
      {showPdfModal && pdfUrl && (
        <PdfPreviewIframe
          pdfUrl={pdfUrl}
          onClose={() => {
            setShowPdfModal(false);
            setPdfUrl(null);
          }}
        />
      )}
    </>
  );
}
